import React from "react"
import {Dialog, Button} from "react-weui"
import * as Feather from "react-feather"
import { connect } from "react-redux"
import ReactMarkdown from "react-markdown"
import { push } from "connected-react-router"
import {get, isEmpty} from "lodash"

import Icon from "../components/icons/Icon"

import Link from "../components/Link.jsx"
import {products, cities} from "../../../../data"
import config from "../../../../config.app"
import Page from "../components/FixedBarPage"
import {isRestaurant, isCompra} from "../tags"

import "./Product.less"
import PigeonMap from "../transportation/components/PigeonMap";

const _dirflg = { PUBLIC_TPT: "r", WALKING: "w", DRIVE: "d" }
function dirflg(x) { return _dirflg[x] || "r" }


function mapsLink(address, rt) {
  if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) {
    return `http://maps.google.com/?daddr=${encodeURIComponent(address)}&dirflg=${dirflg(rt)}`
  }
 else {
    return `http://maps.apple.com/?daddr=${encodeURIComponent(address)}&dirflg=${dirflg(rt)}`
  }
}

class ProductDescription extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { modalDone: false }
  }

  render() {
    const { product } = this.props

    const FirstWarningIcon = get(product, ["firstWarning", "icon"], null) && Feather[product.firstWarning.icon]
    const LastWarningIcon = get(product, ["lastWarning", "icon"], null) && Feather[product.lastWarning.icon]
    // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams#Browser_compatibility
    const searchParams = new URLSearchParams(window.location.search)
    const qr = searchParams.get("qr")

    return (
      <Page
        title={product.chName || product.name}
        footerButton={!isRestaurant(product)}
        pillButton={false}
        onFooterClick={() => {
          if (isCompra(product)) {
            this.props.push(`/catalogo/${this.props.city}/transportation?zone=compras&place=${product._id}`)
          }
          else if (product.relations && product.relations.includes.length > 0) this.props.push(`/catalogo/reservation/ticketselection/${product._id}`)
          else this.props.push(`/catalogo/reservation/selections/${product._id}`)
        }}
        footerLabel={
          isRestaurant(product) ? (
            <div className="restaurantDescriptionButton">
              {isEmpty(product.menus) ? "预定餐位" : "看菜单" }
            </div>
          ) : (
            <div className="restaurantDescriptionButton">
              下一步
            </div>
          )
        }
        __transparentBar
        containerProps={{ id: "productDescription" }}
      >

        {
          qr == "labola" && !this.state.modalDone && (
            <Dialog
              className="explanation-modal"
              id="restaurant-qr"
              type="ios"
              show
            >
              {/* If you want to eat now, come ahead and ask for a table!
                * If you have a free desk, you can do your order from here.
                Puedes usar ZhangShangXBY para ver la carta, elegir tu menú, y hacer una reserva en este restaurante!
                Si lo que quieres es entrar ahora, te recomendamos que entres a ver si hay mesas libres, pero puedes
                usar ZSX para elegir tu pedido en chino.
                */}
              <div className="body">
                <p className="rqr">
                  您可以使用ZhangShangXBY查看菜单，选择菜单，
<strong>并在这家餐厅预订！</strong>
                </p>
                <img src="/static/img/counter.png" />
                <p className="rqr">
                  如果您想立即进入，我们建议您去看看是否有免费桌子，但您可以使用ZSX选择中文订单。
                </p>
              </div>
              <Button onClick={() => this.setState({modalDone: true})}>同意</Button>
            </Dialog>
          )
        }

        {
          isRestaurant(product) && isEmpty(product.menus) && (
            <div className="warning">暂无套餐选择，仅提供预定餐位服务</div>
          )
        }

        {
          /* #TODO recover warnings
           * #TODO don't use type restaurant and shit
          this.props.type == "restaurant" && (
            <div className="warning">
              <Feather.Clock />
              <ReactMarkdown
                source="如果您想现在就餐，请进入餐厅后向服务员询问空桌，入座后便可点餐。"
                style={{display: "inline"}}
                className="markdown"
              />
            </div>
          )
          */
        }

        <div
          className="foreground"
          style={{ backgroundImage: `url(${get(product, ["foreground", "image"]) || product.background.image})` }}
        >
          <div className="priceTag">
            {
              product.ppp ? `大约${product.ppp}€` : `成人票${product.price.general}€`
            }
          </div>
        </div>
        
        <h1>{product.chName}</h1>
        { product.name && <h2>{product.name}</h2> }

        {
          product.firstWarning && product.firstWarning.text && (
            <div className="warning">
              { FirstWarningIcon && <FirstWarningIcon /> }
              <Link to={get(product, ["firstWarning", "link"])}>
                <ReactMarkdown source={product.firstWarning.text} style={{display: "inline"}} className="markdown" />
              </Link>
            </div>
          )
        }

        {
          /* If you want to eat now, come ahead and ask for a table!
          If you have a free desk, you can do your order from here.
      or:
            Puedes usar ZhangShangXBY para ver la carta, elegir tu menú, y hacer una reserva en este restaurante!
            Si lo que quieres es entrar ahora, te recomendamos que entres a ver si hay mesas libres, pero puedes
            usar ZSX para elegir tu pedido en chino.
           */
          qr == "labola" && (
            <div className="warning">
              <Feather.Clock />
              <ReactMarkdown
                source={(
                  "您可以使用ZhangShangXBY查看菜单，选择菜单，并在这家餐厅预订！\n\n"
                  + "如果您想立即进入，我们建议您去看看是否有免费桌子，但您可以使用ZSX选择中文订单。"
                )}
                style={{display: "inline"}}
                className="markdown"
              />
            </div>
          )
        }

        <div className="main">
          <ReactMarkdown source={product.longdescription || product.description} className="markdown" />
        </div>

        {
          product.lastWarning && product.lastWarning.text && (
            <div className="warning">
              { LastWarningIcon && <LastWarningIcon /> }
              <Link to={get(product, ["lastWarning", "link"])}>
                <ReactMarkdown source={product.lastWarning.text} style={{display: "inline"}} className="markdown" />
              </Link>
            </div>
          )
        }

        {
          isRestaurant(product) && (
            <div className="groupButtonIcon">
              <div className="groupButtonText" onClick={() => {
                this.props.push(`/catalogo/reservation/selections/${product._id}`) 
}}>
                <div className="oval">
                  <Icon name="calendar"  />            
                </div>
                <p>预订</p>
              </div>
              <div className="groupButtonText" onClick={() => {
                this.props.push(`/catalogo/menu/${product._id}`)
              }}>
                <div className="oval">
                  <Icon name="book" />            
                </div>
                <p>菜单</p>
              </div>
            </div>
          )
        }
        <div className="maps">
          <div className="titleMaps">位置</div>
          <div className="contentMaps">
            <PigeonMap
              originCoords={[product.preciseLocation.latitude, product.preciseLocation.longitude]}
              city={this.props.city}
              cities={cities}
              height={280}
            />
          </div>
          <div className="bullets">
            <div className="personWalk" onClick={() => {              
              window.location.href = mapsLink(product.address, "WALKING")
            }}>
              <Icon name="personWalk"  />
              <p>步行</p>
            </div>
            <div className="taxi" onClick={() => {
              this.props.push(`/catalogo/Madrid/transportation`)
            }}>
              <Icon name="taxi"  />
              <p>驾车</p>
            </div>
          </div>
        </div>
      </Page>
    )
  }
}

const mapStateToProps = (stateIgnored, ownProps) => {
  const product = products[ownProps.match.params.id] || products[encodeURIComponent(ownProps.match.params.id)]
  return {
    product,
    type: product.type,
    city: product.city
  }
}

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(push(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductDescription)



// WEBPACK FOOTER //
// ./src/app/catalogo/products/ProductDescription.jsx